"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFingerPrinterTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsTableButton = require("../../components/DmsTableButton/DmsTableButton");
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _ClearRounded = _interopRequireDefault(require("@mui/icons-material/ClearRounded"));
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _CreateFingerModal = require("./modals/CreateFingerModal");
var _DeleteFingerModal = require("./modals/DeleteFingerModal");
var _DmsHasFingerPrinterStatus = require("./DmsHasFingerPrinterStatus");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsFingerPrinterTable = () => {
  const table = (0, _react.useRef)(null);
  const token = (0, _DmsTokenHook.getToken)();
  const [selectedRowData, setSelectedRowData] = (0, _react.useState)("");
  const [modalCreate, setShowModalCreate] = (0, _react.useState)(false);
  const [modalDelete, setShowModalDelete] = (0, _react.useState)(false);
  const handleCreateShowModal = async (e, data, originalData) => {
    setSelectedRowData(originalData);
    setShowModalCreate(true);
  };
  const handleDeleteShowModal = async (e, data, originalData) => {
    setSelectedRowData(originalData);
    setShowModalDelete(true);
  };
  const header = [{
    label: _reactIntlUniversal.default.get("User").d("User"),
    column_name: "user_name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("HasFinger").d("Has finger"),
    sortable: false,
    can_create: false,
    can_edit: false,
    element: row => /*#__PURE__*/_react.default.createElement(_DmsHasFingerPrinterStatus.DmsHasFingerPrinterStatus, {
      row: row,
      token: token
    })
  }, {
    label: _reactIntlUniversal.default.get("AddFinger").d("Add finger"),
    width: "80px",
    sortable: false,
    element: /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      columns: "pk",
      icon: /*#__PURE__*/_react.default.createElement(_Add.default, null),
      onClick: handleCreateShowModal
    })
  }, {
    label: _reactIntlUniversal.default.get("DeleteFinger").d("Delete finger"),
    width: "80px",
    sortable: false,
    element: /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
      table: table,
      columns: "pk",
      icon: /*#__PURE__*/_react.default.createElement(_ClearRounded.default, {
        sx: {
          color: 'red'
        }
      }),
      onClick: handleDeleteShowModal
    })
  }];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: '/user/table',
    responsive: true
  }), /*#__PURE__*/_react.default.createElement(_CreateFingerModal.DmsCreateFingerModal, {
    selectedRowData: selectedRowData,
    modalCreate: modalCreate,
    setShowModalCreate: setShowModalCreate,
    token: token
  }), /*#__PURE__*/_react.default.createElement(_DeleteFingerModal.DmsDeleteFingerModal, {
    selectedRowData: selectedRowData,
    modalDelete: modalDelete,
    setShowModalDelete: setShowModalDelete,
    token: token
  }));
};
exports.DmsFingerPrinterTable = DmsFingerPrinterTable;